export default function radiobutton() {
  return {
    restict: 'E',
    transclude: true,
    require: 'ngModel',
    template: `
      <label class="checkmark" ng-disabled="isDisabled">
        <input type="radio" ng-model="model" ng-disabled="isDisabled" name="{{ ::radioName }}" ng-value="literalValue || value" />
        <span></span>
        <span ng-transclude></span>
      </label>
    `,
    scope: {
      isDisabled: '=?ngDisabled',
      value: '=ngValue',
      literalValue: '@value',
      radioName: '@name',
    },
    link($scope, $element, $attrs, $ngModelContorller) {
      $scope.$watch(
        () => $ngModelContorller.$viewValue,
        (value) => {
          $scope.model = value;
        }
      );

      $scope.$watch('model', (m) => $ngModelContorller.$setViewValue(m));
    },
  };
}
